<template>
  <div>
    <div
      class="image-text-container"
      :style="{
        backgroundImage: `url(${configDataForm.backgroundImageFullUrl || noUpload})`,
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',
      }"
      @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
      @mouseleave="handleShowOperationBtn(false)"
    >
      <span class="image-text-container-text">
        <div class="image-text-container-text-title-row">
          <span class="image-text-container-text-title fadeInLeft">{{
            configDataForm.title
          }}</span>
          <span
            v-if="configDataForm.subTitle"
            class="image-text-container-text-sub-title fadeInLeft"
          >
            {{ configDataForm.subTitle }}
          </span>
        </div>
        <span
          class="image-text-container-text-content fadeInLeft"
          v-html="configDataForm.content"
        ></span>
      </span>
      <operation-container
        v-if="showOperationBtn && !showEditForm"
        :component-data="props.componentData"
        :show-edit-content-button="props.showEditContentButton"
        :show-edit-components-button="props.showEditComponentsButton"
        :show-delete-components-button="props.showDeleteComponentsButton"
        :show-insert-components-button="props.showInsertComponentsButton"
        :show-sort-components-button="props.showSortComponentsButton"
        @handle-show-edit-form="handleShowEditForm"
        @handle-change-components="handleChangeComponents"
        @handle-delete-components="handleDeleteComponents"
        @handle-insert-components="handleInsertComponents"
        @handle-sort-components="handleSortComponents"
      ></operation-container>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <image-text-edit-form
        v-if="showEditForm"
        v-model="configDataForm"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></image-text-edit-form>
    </el-drawer>
  </div>
</template>
<script setup>
// #region 引用
import OperationContainer from '../common/OperationContainer.vue';
import ImageTextEditForm from './ImageTextEditFormFive.vue';
// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

// console.log('props-configDataForm:',props);

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 表单绑定对象
const configDataForm = ref({
  contentImageObj: null,
  imageName: '',
  imageFileKey: 'contentImage',
  backGroundImageObj: null,
  backgroundImageName: '',
  backgroundImageFileKey: 'backgroundImage',
  title: '示例标题',
  content: '示例内容',
  textColor: '#ffffff',
  backgroundColor: '#008bd5',
});

if (props.componentData.configData) {
  // 服务器渲染的直接调用
  configDataForm.value = JSON.parse(props.componentData.configData);
  // 后台编辑的处理一下
  // nextTick(() => {
  //   configDataForm.value = JSON.parse(props.componentData.configData);
  // });
}

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // console.log('configDataForm--1:', configDataForm);
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataForm.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* PC端样式 */
@include pc {
  .image-text-container {
    position: relative;
    display: flex;
    align-items: self-start;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    height: 78vh;
    margin: auto;
  }

  .image-text-container img {
    width: 100%;
    height: 100%;
  }

  .image-text-container-text {
    display: flex;
    flex-direction: column;
    width: 1200px;
    margin-top: 60px;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 16px;
    font-style: normal;
    line-height: 25px;
    color: #fff;
    letter-spacing: 1px;
    white-space: pre-wrap;
  }

  .image-text-container-text-title-row {
    display: flex;
    align-items: center;
  }

  .image-text-container-text-title {
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 80px;
    color: #fff;
  }

  .image-text-container-text-sub-title {
    margin-left: 10px;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 16px;
    color: #00a0d0;
  }
}

/* 移动端样式 */
@include mobile {
  .image-text-container {
    width: 100%;
    padding: 4vw 3vw;
    margin: 0;
  }

  .image-text-container img {
    width: 100%;
    height: 100%;
  }

  .image-text-container-text {
    display: flex;
    flex-direction: column;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 4vw;
    font-style: normal;
    line-height: 1.8;
    color: #fff;
    letter-spacing: 1px;
    white-space: pre-wrap;
    text-align: justify;
  }

  .image-text-container-text-title-row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .image-text-container-text-title {
    padding-bottom: 2vw;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-size: 5vw;
    font-style: normal;
    font-weight: 700;
    line-height: 1.4;
    color: #fff;
  }

  .image-text-container-text-sub-title {
    padding-bottom: 2vw;
    font-size: 4vw;
    color: #00a0d0;
  }
}
</style>
